import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Separator } from '@/components/ui/separator';
import { Command } from 'lucide-react';

const shortcuts = [
  { category: 'Navigation', items: [
    { keys: ['Ctrl', 'K'], description: 'Open AI Command Bar' },
    { keys: ['Ctrl', 'B'], description: 'Toggle Sidebar' },
    { keys: ['Ctrl', '/'], description: 'Show Keyboard Shortcuts' },
  ]},
  { category: 'Quick Actions', items: [
    { keys: ['Ctrl', 'N'], description: 'New Report / Deal / Complaint' },
    { keys: ['Ctrl', 'S'], description: 'Save Current Form' },
    { keys: ['Ctrl', 'E'], description: 'Export Data' },
  ]},
  { category: 'Views', items: [
    { keys: ['Ctrl', '1'], description: 'Go to Dashboard' },
    { keys: ['Ctrl', '2'], description: 'Go to Work Reporter' },
    { keys: ['Ctrl', '3'], description: 'Go to Complaints' },
    { keys: ['Ctrl', '4'], description: 'Go to Sales' },
  ]},
];

export function KeyboardShortcutsModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Command className="w-5 h-5" /> Keyboard Shortcuts
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-5 py-2 max-h-[60vh] overflow-y-auto">
          {shortcuts.map((group) => (
            <div key={group.category}>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2">{group.category}</p>
              <div className="space-y-2">
                {group.items.map((s, i) => (
                  <div key={i} className="flex items-center justify-between" data-testid={`shortcut-${i}`}>
                    <span className="text-sm text-slate-700 dark:text-slate-300">{s.description}</span>
                    <div className="flex items-center gap-1">
                      {s.keys.map((key, ki) => (
                        <span key={ki}>
                          <kbd className="px-2 py-0.5 text-xs font-mono bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded text-slate-600 dark:text-slate-400">
                            {key}
                          </kbd>
                          {ki < s.keys.length - 1 && <span className="text-slate-400 mx-0.5">+</span>}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              {group !== shortcuts[shortcuts.length - 1] && <Separator className="mt-4" />}
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
